export const FLOOD = 'flood';
export const DOOR_OPEN = 'doorOpen';
export const SMOKE = 'smoke';
export const BINARY = 'binary';
export const MOTION = 'motion';

export const allTypes = [FLOOD, DOOR_OPEN, SMOKE, BINARY, MOTION];
